export class ProcessInstanceState {
    Code: string;
    Name: string;
}